import { Skeleton } from "./Skeleton"

export function SingleColumnSkeleton() {
	return (
		<div>
			<div className="mb-2 flex items-center px-2">
				<Skeleton className="h-4 w-24" />
				<Skeleton className="ml-auto h-3 w-10" />
			</div>
			<div className="space-y-0.5">
				{[0, 1, 2, 3, 4].map(i => (
					<HolderRowSkeleton key={i} />
				))}
			</div>
		</div>
	)
}

export function GridSkeleton() {
	return (
		<div className="grid gap-6 sm:grid-cols-2">
			{[0, 1].map(idx => (
				<div key={idx}>
					<div className="mb-2 flex items-center px-2">
						<Skeleton className="h-4 w-24" />
						<Skeleton className="ml-auto h-3 w-10" />
					</div>
					<div className="space-y-0.5">
						{[0, 1, 2, 3, 4].map(i => (
							<HolderRowSkeleton key={`${idx}-${i}`} />
						))}
					</div>
				</div>
			))}
		</div>
	)
}

function HolderRowSkeleton() {
	return (
		<div className="flex items-center gap-2 px-2 py-1.5">
			<Skeleton className="size-7 rounded-full" />
			<Skeleton className="h-4 max-w-[120px] flex-1" />
			<Skeleton className="ml-auto h-4 w-10" />
		</div>
	)
}
